<template>
  <div class="payment_request_btn_wrap">
    <template v-if="supported">
      <p class="mb-0 mr-2 text-primary"><strong>Or Continue With</strong></p>
      <div
        id="paymentIntentBtn"
        style="width: 190px;"
      />

      <v-snackbar
        v-model="showError"
        color="error"
        bottom
      >
        {{ error }}
        <v-btn
          dark
          text
          @click="showError = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </template>
  </div>
</template>
<script type="text/javascript">
import find from 'lodash.find'

export default {
  name: 'PaymentRequestBtn',

  data () {
    return {
      stripeInstance: null,
      paymentRequest: null,
      paymentIntent: {},
      showError: false,
      error: null,
      supported: false,
      loading: false
    }
  },

  watch: {
    loading: function () {
      this.$emit('loading:changed', this.loading)
    },
    '$store.getters.bookingForm.bikes': {
      deep: true,
      handler: function () {
        this.paymentRequest.update({
          displayItems: this.bikeTotals.displayItems,
          total: {
            label: 'Booking Total',
            amount: this.bikeTotals.stripeRunningTotal
          }
        })
      }
    }
  },

  mounted () {
    // eslint-disable-next-line
    this.stripeInstance = Stripe(process.env.VUE_APP_STRIPE_KEY)
    this.setupPaymentRequest()
    this.setupButton()
    this.listenForPayment()
    this.listenForCancel()
  },

  computed: {
    bikeTotals () {
      var items = []
      var runningTotal = 0
      this.$store.getters.bookingForm.bikes.forEach(bike => {
        var service = find(this.$store.getters.services, { 'sku': bike.service_sku })
        if (service) {
          runningTotal = runningTotal + service.price
          items.push({
            amount: Math.round(service.price * 100),
            label: `${bike.manafacturer} ${bike.model} - ${service.name} Service`
          })
        }
      })
      return {
        displayItems: items,
        runningTotal: runningTotal,
        stripeRunningTotal: Math.round(runningTotal * 100)
      }
    }
  },

  methods: {
    setupPaymentRequest () {
      this.paymentRequest = this.stripeInstance.paymentRequest({
        country: 'GB',
        currency: 'gbp',
        total: {
          label: 'Booking Total',
          amount: this.bikeTotals.stripeRunningTotal
        },
        displayItems: this.bikeTotals.displayItems,
        requestPayerName: true,
        requestPayerPhone: true,
        requestPayerEmail: true
      })
    },

    setupButton () {
      var elements = this.stripeInstance.elements()
      var prButton = elements.create('paymentRequestButton', {
        paymentRequest: this.paymentRequest,
        style: {
          type: 'book',
          theme: 'light',
          height: 44
        }
      })

      // Check the availability of the Payment Request API first.
      this.paymentRequest.canMakePayment().then(result => {
        if (result) {
          this.supported = true
          this.$nextTick(() => {
            prButton.mount('#paymentIntentBtn')
          })

          prButton.on('click', $e => {
            this.$emit('button:click', {
              ...$e,
              ...{
                callback: () => {
                  this.loading = true
                }
              }
            })
          })
        }
      })
    },

    listenForPayment () {
      this.paymentRequest.on('paymentmethod', $e => {
        this.postBookingApi($e)
          .then(data => {
            this.$store.commit('setBooking', data.data)
            this.getPaymentIntent(data.data.id)
              .then(paymentIntent => {
                this.paymentIntent = paymentIntent
                this.stripeInstance.confirmCardPayment(
                  this.paymentIntent.client_secret,
                  { payment_method: $e.paymentMethod.id, setup_future_usage: 'off_session' },
                  { handleActions: false }
                ).then(confirmResult => {
                  if (confirmResult.error) {
                    this.loading = false
                    this.showError = true
                    this.error = 'There was an error processing the payment!'
                    $e.complete('fail')
                  } else {
                    $e.complete('success')
                    this.$router.push({ name: 'completePage', params: { bookingId: data.data.id, apiSignature: data.data.signed_show.signature } })
                  }
                })
              })
              .catch(error => {
                this.loading = false
                this.showError = true
                this.error = error.message
              })
          })
          .catch(error => {
            this.loading = false
            this.showError = true
            this.error = error.message
          })
      })
    },

    listenForCancel () {
      this.paymentRequest.on('cancel', $e => {
        this.loading = false
      })
    },

    postBookingApi ($e) {
      var persistType = this.$store.getters.booking.signed_update ? 'put' : 'post'
      return this.$api.persist(persistType, {
        path: this.$store.getters.booking.signed_update ? `bookings/${this.$store.getters.booking.id}/signed?signature=${this.$store.getters.booking.signed_update.signature}` : 'bookings',
        object: {
          ...this.$store.getters.bookingFormToApi,
          ...{
            with: ['bikes.service']
          },
          ...{
            customer_name: $e.payerName,
            customer_email: $e.payerEmail,
            customer_mobile: $e.payerPhone
          }
        }
      })
    },

    stopLoading () {
      this.loading = false
    },

    getPaymentIntent (bookingId) {
      return this.$api.persist('post', {
        path: 'payments',
        object: {
          current_intent: this.paymentIntent.id,
          booking_id: bookingId
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
  .payment_request_btn_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
